import { render } from "./EventAddPage.vue?vue&type=template&id=1ab984a4&scoped=true"
import script from "./EventAddPage.vue?vue&type=script&lang=js"
export * from "./EventAddPage.vue?vue&type=script&lang=js"

import "./EventAddPage.vue?vue&type=style&index=0&id=1ab984a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab984a4"]])

export default __exports__